/**
 * 腾讯会议hooks
 */
import { inject, ref } from 'vue'
import { getStorage } from '@/plugins/store'
import { ITecentMeetingObject } from '../types'
export default () => {
  const { creatMyMeeting, getTeachingActivityTecentMeeting, deleteMyMeeting } = inject<any>('$http')

  /**
   * 创建会议
   * @param params
   */
  const createTecentMeeting = async params => {
    const res = await creatMyMeeting(params)
    return res
  }

  /**
   * 会议授权
   * @param redirectUri 重定向地址
   * @param meetingId 会议id
   * @param isDelete 是否删除
   */
  const getAuthMeeting = (redirectUrl: string, meetingId: string, isDelete = false) => {
    const userInfo = getStorage('userInfo')
    if (isDelete) {
      window.location.href = `${window.location.protocol}//${window.location.host}/homepage/hike-boot/txhy/auth/getAuthorize?logInUserId=${userInfo.id}&meetingId=${meetingId}&redirectUri=${redirectUrl}&reqType=1`
    } else {
      window.location.href = `${window.location.protocol}//${window.location.host}/homepage/hike-boot/txhy/auth/getAuthorize?logInUserId=${userInfo.id}&meetingId=${meetingId}&redirectUri=${redirectUrl}`
    }
  }

  /**
   * 获取会议信息
   * @param meeting_id 会议id
   */
  const meetingInfo = ref<ITecentMeetingObject>()
  const getTecentMeetingInfo = async (meeting_id: string) => {
    const res = await getTeachingActivityTecentMeeting({ meeting_id })
    meetingInfo.value = res
  }

  /**
   * 删除会议
   * @param meetingId 会议id
   */
  const deleteTecentMeeting = async (meetingId: string) => {
    await deleteMyMeeting({ meetingId })
  }

  return {
    meetingInfo,
    createTecentMeeting,
    getAuthMeeting,
    getTecentMeetingInfo,
    deleteTecentMeeting
  }
}
